import { SpacingProps } from "@mui/system";
import { ButtonProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Button, MUIButtonProps } from "@/components/molecules/Button";
import { Color } from "@/common/types";
import { CommonConstants } from "@/common/CommonConstants";
import { useEffect, useState } from "react";

export type ButtonType =
  | "BackToList"
  | "Cancel"
  | "Delete"
  | "Register"
  | "Save"
  | "Replace"
  | "Return"
  | "Edit"
  | "Detail"
  | "Search"
  | "ResetSearchCriteria"
  | "Singup"
  | "BatchExecution"
  | "Add"
  | "DownloadCSV"
  | "RegisterReason";

interface CommonButtonProps {
  onClickBtn?: () => void;
  btnType: ButtonType;
}
export const CommonButton = (
  props: CommonButtonProps & MUIButtonProps & ButtonProps & SpacingProps
) => {
  const { btnType, onClickBtn, ...propsOpt } = props;
  const [labelByType, setLabelByType] = useState("");
  const [bgcByType, setBgcByType] = useState<Color>("transparent");
  const theme = useTheme();

  useEffect(() => {
    if (btnType) {
      let label = "";
      let backgroundColor: Color = "transparent";
      switch (btnType) {
        case "BackToList":
          label = CommonConstants.BackToList;
          backgroundColor = "#cccccd";
          break;
        case "Cancel":
          label = CommonConstants.Cancel;
          backgroundColor = "#cccccd";
          break;
        case "Delete":
          label = CommonConstants.Delete;
          backgroundColor = "#E71A19";
          break;
        case "Register":
          label = CommonConstants.Register;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "Save":
          label = CommonConstants.Save;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "Replace":
          label = CommonConstants.Replace;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "Return":
          label = CommonConstants.Return;
          backgroundColor = "#cccccd";
          break;
        case "Search":
          label = CommonConstants.Search;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "Edit":
          label = CommonConstants.Edit;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "Detail":
          label = CommonConstants.Detail;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "ResetSearchCriteria":
          label = CommonConstants.ResetSearchCriteria;
          backgroundColor = "#cccccd";
          break;
        case "Singup":
          label = CommonConstants.Singup;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "BatchExecution":
          label = CommonConstants.BatchExecution;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        case "Add":
          label = CommonConstants.Add;
          backgroundColor = theme.palette.primary.dark as Color;
          break;
        case "DownloadCSV":
          label = CommonConstants.DownloadCSV;
          backgroundColor = theme.palette.primary.dark as Color;
          break;
        case "RegisterReason":
          label = CommonConstants.RegisterReason;
          backgroundColor = theme.palette.primary.main as Color;
          break;
        default:
          label = "";
          backgroundColor = "transparent";
          break;
      }
      setLabelByType(label);
      setBgcByType(backgroundColor);
    } else {
      setLabelByType("");
      setBgcByType("transparent");
    }
  }, [btnType, theme]);

  return (
    <Button
      {...propsOpt}
      sx={{ ...props.sx, backgroundColor: bgcByType }}
      onClick={() => {
        onClickBtn && onClickBtn();
      }}
      label={labelByType}
    />
  );
};
